import { useEffect, useRef } from "react";
import { safePlay } from "@util/utils";

export const useVideoAutoPlay = (threshold: number = 0.6) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    const videoElement = videoRef.current;

    if (!videoElement) return;

    const handleIntersection = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          safePlay(videoElement);
        } else {
          videoElement.pause();
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold,
    });

    observer.observe(videoElement);

    return () => {
      observer.disconnect();
    };
  }, [threshold]);

  return videoRef;
};
